module.exports = __webpack_public_path__ + "static/media/mostrarMapas.e31f45f0.svg";